import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, Inbox, Users, Briefcase, FileText, MessageCircleQuestion, Star, UserPlus, UserCog } from "lucide-react";
import { useAuth } from "@/lib/auth";

const TABS = [
    { to: "/admin", label: "Briefs", icon: Inbox, exact: true },
    { to: "/admin/clients", label: "Clients", icon: Users },
    { to: "/admin/projects", label: "Projects", icon: Briefcase },
    { to: "/admin/invoices", label: "Invoices", icon: FileText },
    { to: "/admin/team", label: "Team", icon: UserCog },
    { to: "/admin/questions", label: "Q&A", icon: MessageCircleQuestion },
    { to: "/admin/feedback", label: "Feedback", icon: Star },
    { to: "/admin/careers", label: "Careers", icon: UserPlus },
];

export default function AdminShell({ children }) {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    return (
        <main data-testid="admin-shell" className="min-h-screen bg-ink text-bone">
            <header className="sticky top-0 z-30 bg-ink/80 backdrop-blur-xl border-b border-white/10">
                <div className="max-w-[1500px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                    <Link
                        to="/admin"
                        className="flex items-center gap-3"
                        data-testid="admin-brand"
                    >
                        <img
                            src="/logo.png"
                            alt="Aximo Studios"
                            className="h-9 w-auto"
                        />
                        <span className="font-display text-base tracking-tight text-bone-300 hidden sm:inline">
                            /Briefcase
                        </span>
                    </Link>

                    <nav className="hidden md:flex items-center gap-1">
                        {TABS.map((t) => {
                            const Icon = t.icon;
                            const active = t.exact
                                ? pathname === t.to
                                : pathname.startsWith(t.to);
                            return (
                                <Link
                                    key={t.to}
                                    to={t.to}
                                    data-testid={`admin-tab-${t.label.toLowerCase()}`}
                                    className={`px-3 h-10 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] border transition-colors ${
                                        active
                                            ? "border-ember text-ember"
                                            : "border-transparent text-bone-300 hover:text-bone"
                                    }`}
                                >
                                    <Icon className="w-3.5 h-3.5" />
                                    {t.label}
                                </Link>
                            );
                        })}
                    </nav>

                    <div className="flex items-center gap-3">
                        {user && (
                            <span className="hidden sm:inline text-xs text-bone-500">
                                {user.email}
                            </span>
                        )}
                        <button
                            onClick={() => {
                                logout();
                                navigate("/");
                            }}
                            data-testid="admin-logout"
                            className="inline-flex items-center gap-2 h-10 px-4 border border-white/15 hover:border-white/30 transition-colors text-xs uppercase tracking-[0.18em]"
                        >
                            <LogOut className="w-3.5 h-3.5" />
                            Sign out
                        </button>
                    </div>
                </div>
            </header>
            <div className="max-w-[1500px] mx-auto px-6 lg:px-10 py-8">
                {children}
            </div>
        </main>
    );
}
